import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading2} from "./deferLoaderHoc";
import {getUsers} from "../../actions/users";
import CompanyCard from "./CompanyCard";
import Spinner from 'react-spinkit';

export const ContactCard_View = ({ user }) => {
  const {
    resource: {
      firstname,
      lastname,
      title,
      email,
      phone,
      fax,
      cell,
      companyid,
      companyadmin,
    }
  } = user;
  const full_name = [firstname, lastname].filter(i => i).join(' ') || 'No Name';
  if (email && !companyid) {
    return (
      <div className='contact-card'>
        <a href={'mailto:' + email}>{email}</a>
      </div>
    );
  } else {
    return (
      <div className='contact-card'>
        <div className='contact-card-user-info'>
          <h3>{full_name}{companyadmin && <span className='font-small'>{' '}(Company Admin)</span>}</h3>
          <div>{title}</div>
          <div><a href={'mailto:' + email}>{email}</a></div>
          <div>p: <a href={'tel:' + phone}>{phone}</a></div>
          <div>f: <a href={'tel:' + fax}>{fax}</a></div>
          <div>c: <a href={'tel:' + cell}>{cell}</a></div>
        </div>
        <div>
          <CompanyCard id={companyid}/><br/>
        </div>
      </div>
    );
  }
};

ContactCard_View.propTypes = {};

const mapState = (state, ownProps) => {
  let user = state.users.data[ownProps.id];
  if (!user) return { user: { resource: { id: ownProps.id }, cache: { loading: true }}};
  return { user };
};

export default compose(
  connect(mapState),
  withLoading2(
    ({ user: { resource: { id }}}, dispatch) => dispatch(getUsers(id)),
    () => <Spinner name='line-scale'/>,
    null,
    ['user']
  )
)(ContactCard_View);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ContactCard.js